import { FC } from 'react';

import { Universe } from '../../types';
import { Button } from '../ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '../ui/Dialog';

interface Props {
    open: boolean;
    universes: Universe[];
    onSelect: (universe: Universe) => void;
}

export const UniverseSelectionDialog: FC<Props> = ({
    open,
    universes,
    onSelect,
}) => {
    return (
        <Dialog open={open}>
            <DialogContent
                className="w-[calc(100%-2rem)] rounded-2xl sm:rounded-2xl sm:max-w-xl"
                hideCloseButton
                onPointerDownOutside={(event) => event.preventDefault()}
                onEscapeKeyDown={(event) => event.preventDefault()}
            >
                <DialogHeader>
                    <DialogTitle>Оберіть основну гру</DialogTitle>
                    <DialogDescription>
                        Це допоможе нам показувати найбільш релевантний контент на сайті.
                    </DialogDescription>
                </DialogHeader>

                <div className="grid gap-3 sm:grid-cols-2">
                    {universes.map((universe) => (
                        <Button
                            key={universe.id}
                            type="button"
                            variant="outline"
                            className="h-auto justify-start rounded-xl px-4 py-4 text-left"
                            onClick={() => onSelect(universe)}
                        >
                            <div className="flex flex-col items-start">
                                <span className="font-semibold">
                                    {universe.name}
                                </span>
                            </div>
                        </Button>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
};
